module.exports = __webpack_public_path__ + "img/part1-bg.34a4cab3.png";